<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建创意类型</el-button>
        </li>
        <li>
          <span>创意类型名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryIdeaTypeName" @input="getList"></el-input>
        </li>
        <li>
          <span>状态：</span>
          <el-select size="small" v-model="queryStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in myOption.status" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>代码位类型：</span>
          <el-select size="small" v-model="querySlotType" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in [...myOption.selectAll, ...myOption.slotType]" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="创意素材">
                <table class="assets-table">
                  <tr v-for="(item,index) in JSON.parse(props.row.assets)" :key="index">
                    <td>{{`${myOption.getIdData('ideaType',item.assetsId,'name')}：`}}</td>
                    <td>{{`${item.required===1?'必填':'选填'}`}}</td>
                    <template v-if="item.img">
                      <td>{{`图片宽度（${item.img.width?item.img.width+'px':'不限'}）`}}</td>
                      <td>{{`图片高度（${item.img.height?item.img.height+'px':'不限'}）`}}</td>
                      <td>{{`图片类型（${item.img.mimes.join('、').replace(/image\//g,'')}）`}}</td>
                    </template>
                    <template v-if="item.data">
                      <td>{{`最小长度（${item.data.minLen?item.data.minLen+'个字符':'不限'}）`}}</td>
                      <td>{{`最长长度（${item.data.maxLen?item.data.maxLen+'个字符':'不限'}）`}}</td>
                    </template>
                  </tr>
                </table>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="ideaTypeId" label="ID" min-width="100px"></el-table-column>
        <el-table-column prop="ideaTypeName" label="创意类型名称" min-width="200px"></el-table-column>
        <el-table-column prop="createType" label="创意类型归属" min-width="200px"></el-table-column>
        <el-table-column prop="slotType" label="代码位类型" min-width="150px"></el-table-column>
        <el-table-column prop="ideaNum" label="创意统计" min-width="150px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="!statusPower" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setStatus(tableData[scope.$index])"></el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="addPower || deletePower || modifyPower" min-width="150px">
          <template slot="header" slot-scope="scope">
            操作
            <i class="el-icon-question" title="创意统计 >0 时，禁用修改、删除操作"></i>
          </template>
          <template slot-scope="scope">
            <el-button v-if="addPower" type="text" size="small" style="color:#67C23A;" @click="setAddAndModify(tableData[scope.$index], true)">复制</el-button>
            <template v-if="tableData[scope.$index].createType!=='系统内置'">
              <el-button v-if="modifyPower && tableData[scope.$index].ideaNum===0" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
              <el-button v-if="deletePower && tableData[scope.$index].ideaNum===0" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: true,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      queryStatus: '',
      queryIdeaTypeName: '',
      querySlotType: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.ideaType.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[600].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 获取缓存筛选数据
    this.myOption.getScreenData(this, 'screen-ideaType')
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify({
          slotType: this.querySlotType,
          ideaTypeName: this.queryIdeaTypeName,
          status: this.queryStatus,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.slotType = this.myOption.getIdData('slotType', val.slotType, 'name')
            val.createType = this.myOption.getIdData('createType', val.createType, 'name')
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data, isCopy) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.ideaTypeId, copy: isCopy || false})
      }
      let param = {}
      if (this.queryIdeaTypeName !== '') {
        param.queryIdeaTypeName = this.queryIdeaTypeName
      }
      if (this.queryStatus !== '') {
        param.queryStatus = this.queryStatus
      }
      if (this.querySlotType !== '') {
        param.querySlotType = this.querySlotType
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-ideaType', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.ideaTypeName}" 创意类型`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            ideaTypeIds: param.ideaTypeId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除创意类型成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用
    setStatus (param) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.status.id
        },
        url: this.myOption.requestUrl + this.thisModule.status.api,
        data: this.qs.stringify({
          ideaTypeId: param.ideaTypeId,
          status: param.status
        })
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$message.success(`${param.status === 1 ? '启用' : '禁用'}创意类型成功`)
        } else {
          this.myOption.abnormalCode(this, code)
          param.status = !param.status
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        param.status = !param.status
      })
    }
  }
}
</script>

<style scoped>
.assets-table td{
  padding: 0 10px;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/idea_type/List.vue